import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import goTo from "vuetify/lib/services/goto";
// import "vuetify/dist/vuetify.min.css";
import pl from "vuetify/es5/locale/pl";

import { i18n } from "../main";

Vue.use(Vuetify);
const opts = {
  customVariables: ["~/styles/variables.scss"],
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#0031e2",
        secondary: "#ffd469",
        accent: "#44d3af",
        error: "#f96b6b",
        warning: "#ffd469",
        info: "#6b90ff",
        success: "#44d3af"
      }
    }
  },
  customProperties: true,
  icons: {
    iconfont: "md"
  },
  // iconfont: "md",
  lang: {
    t: (key, ...params) => i18n.t(key, params),
    locales: { pl },
    current: "pl"
  }
};

export function createVuetify() {
  const vuetify = new Vuetify(opts);
  goTo.framework = vuetify.framework;
  return vuetify;
}

export default new createVuetify(opts);
